import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl';
import withNavigate from '../../components/common/withNavigate'
import AlertsPlusTemplateForm from './AlertsPlusTemplateForm';
import AlertsPlusTemplateSuccess from './AlertsPlusTemplateSuccess';
import './AlertsPlusTemplate.css';

class AlertsPlusTemplate extends React.Component {
  state = {
    method: 'POST',
    page: 'form'
  };

  switchPage(method, page) {
    this.setState({method, page})
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('id')){
      this.setState({method: 'PUT'},()=>{
        console.log(this.state);
      });
    }
    window.resizeTo(1080,720)
  }

  renderSwitch(page) {
    switch(page) {
      case 'form':
        return <AlertsPlusTemplateForm method={this.state.method} onSuccess={(method)=>{this.switchPage(method, 'success')}} />;
      case 'success':
        return <AlertsPlusTemplateSuccess methodText={this.state.method === 'POST' ? 'created' : 'updated'}/>
      default:
        return <AlertsPlusTemplateForm method={this.state.method}/>;
    }
  }

  render () {
    return (
      <div className='container-fluid'>
        <div className='row header'>
          <div className='col template-header'>
            <h3><FormattedMessage id="ALERT_PLUS_TEMPLATE_MAKER" /></h3>
          </div>
        </div>
        <div className='card shadow'>
          <div className='row'>
              {this.renderSwitch(this.state.page)}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(AlertsPlusTemplate))
